import React, { useEffect, useRef, useState } from 'react'
import BasicInformationSection from './partial/BasicInformationSection';
import { useDispatch } from 'react-redux';
import ActivityMeetingPointAddressSection from './partial/ActivityMeetingPointAddressSection';
import PickupDropAvailabilitySection from './partial/PickupDropAvailabilitySection';
import WhatYouGetSection from './partial/WhatYouGetSection/WhatYouGetSection';
import { postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { loaderActions } from '../../../../_actions/loader.actions';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { getactivitymanagebyid } from '../../ActivitymasterUtility';
import { decrpt, encrypt } from '../../../commonClass/enc_dec/enc_dec';

const ActivityBasicInfo = ({ basicInfoTab, setBasicInfoTab, dropdownData, editDisabled, setEditDisabled, disabled, setDisabled, setSelectTab }) => {

    const dispatch = useDispatch();
    const [formErrors, setFormErrors] = useState(null);

    // const list = [
    //     { label: 'item 1', value: 1 },
    //     { label: 'item 2', value: 2 },
    //     { label: 'item 3', value: 3 },
    //     { label: 'item 4', value: 4 },
    // ]

    //#region payload data
    //#region basic information section
    const [BasicInformationForm, setBasicInformationForm] = useState({
        ActivityBasicInfoId: 0,
        SupplierId: 0,
        CollectionId: 0,
        CategoryId: 0,
        ActivityId: 0,
        ShortDescriptions: "",
        LongDescriptions: "",
        Highlights: "",
        IsActive: true,
    })
    //#endregion

    //#region activity/meeting point address section
    const defaultPointAddressForm = {
        ActivityManageAddressId: 0, StateId: 0, LocationId: 0, PinCode: "",
        Landmark: "", Latitude: "", Longitude: "", AddressLine: "",
    }

    const [PointAddressForm, setPointAddressForm] = useState({
        IsMeetingPointSameAsActivityAddress: false,
        ActivityBasicInfoAddress: [
            {
                ...defaultPointAddressForm,
                IsActivePointAddress: true
            },
            {
                ...defaultPointAddressForm,
                MobileNo: "",
                EmailId: "",
                IsActivePointAddress: false
            }
        ]
    })
    //#endregion

    //#region pickup/drop availability section
    const [PickUpDropPointXML, setPickUpDropPointXML] = useState([]);
    const [PickUpDropDelete, setPickUpDropDelete] = useState([]);
    //#endregion

    //#region what you get section
    const [WhatYouGetList, setWhatYouGetList] = useState({
        Inclusion: [],
        Exclusion: [],
        ThingsToAvoid: [],
        ThingsToCarried: [],
        OtherInfo: [],
    })
    const [WhatYouGetDelete, setWhatYouGetDelete] = useState([]);
    //#endregion

    //#endregion

    //#region section's ref
    const BasicInformationSectionRef = useRef(null);
    const ActivityMeetingPointAddressSectionRef = useRef(null);
    const PickupDropAvailabilitySectionRef = useRef(null);
    const WhatYouGetSectionRef = useRef(null);
    //#endregion

    //#region set retrieve data
    useEffect(() => {
        if (basicInfoTab) {
            const { BasicInformationForm, PointAddressForm, PickUpDropPointXML, WhatYouGetList } = basicInfoTab;
            setBasicInformationForm(BasicInformationForm);
            setPointAddressForm(PointAddressForm);
            setPickUpDropPointXML(PickUpDropPointXML);
            setWhatYouGetList(WhatYouGetList);
        }
    }, [basicInfoTab])
    //#endregion

    const retrieveAPI = async (ActivityManageId) => {
        const retrieveData = await getactivitymanagebyid(ActivityManageId, dropdownData?.cityList);
        retrieveData && setBasicInfoTab(retrieveData);
    }

    useEffect(() => {
        const getAMId = localStorage.getItem('ami') ? localStorage.getItem('ami') : 0;
        const ActivityManageId = !['0', 0]?.includes(getAMId) ? decrpt(getAMId) : getAMId;
        !['0', 0]?.includes(ActivityManageId) && retrieveAPI(ActivityManageId);
    }, [localStorage.getItem('ami')])

    //#region validations on "Save & Proceed" button
    const validateData = () => {
        let status = true;

        const BasicInformationErrors = BasicInformationSectionRef?.current?.canValidate
            && typeof BasicInformationSectionRef?.current?.ValidateBasicInformationForm === "function" ?
            BasicInformationSectionRef?.current?.ValidateBasicInformationForm() : {};

        const ActivityMeetingPointAddressErrors = ActivityMeetingPointAddressSectionRef?.current?.canValidate && typeof ActivityMeetingPointAddressSectionRef?.current?.ValidateActivityMeetingPointAddressForm === "function" ?
            ActivityMeetingPointAddressSectionRef?.current?.ValidateActivityMeetingPointAddressForm() : {};

        const PickupDropAvailabilityErrors = PickupDropAvailabilitySectionRef?.current?.canValidate && typeof PickupDropAvailabilitySectionRef?.current?.validatePickupDropCollection === "function" ?
            PickupDropAvailabilitySectionRef?.current?.validatePickupDropCollection() : {};

        const validateWhatYouGetSection = WhatYouGetSectionRef?.current?.canValidate && typeof WhatYouGetSectionRef?.current?.validateWhatYouGetSection === "function" ?
            WhatYouGetSectionRef?.current?.validateWhatYouGetSection() : {};

        const error = { ...BasicInformationErrors, ...ActivityMeetingPointAddressErrors, ...PickupDropAvailabilityErrors, ...validateWhatYouGetSection }

        setFormErrors(error);

        if (Object.keys(error)?.length > 0) {
            status = false;
            const id = Object.keys(error)?.[0];
            document.getElementById(id)?.focus();
        }

        return status;
    }
    //#endregion

    //#region save function
    const handleSave = async () => {
        if (validateData()) {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                const user = GetLocalStorage();
                const payloadData = {
                    ...BasicInformationForm,
                    ...PointAddressForm,
                    PickUpDropDelete,
                    PickUpDropPointXML,
                    ...WhatYouGetList,
                    WhatYouGetDelete,
                    UserId: user?.userMasterID
                }

                const upsertactivitybasicinfo = await postUsersData('/master/v1/upsertactivitybasicinfo', payloadData);
                if (upsertactivitybasicinfo?.status) {
                    setSelectTab(2);
                    localStorage.setItem("ami", encrypt(upsertactivitybasicinfo?.data));
                    retrieveAPI(upsertactivitybasicinfo?.data);
                    // dispatch({ type: 'ALERTING', message: upsertactivitybasicinfo?.message });
                }
                else {
                    dispatch({ type: 'ALERTING', message: upsertactivitybasicinfo?.message });
                }
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            }
        }
    }
    //#endregion


    return (
        <div className="container-fluid my-5">

            {/* Basic Information */}
            <BasicInformationSection
                ref={BasicInformationSectionRef}
                BasicInformationForm={BasicInformationForm}
                setBasicInformationForm={setBasicInformationForm}
                formErrors={formErrors}
                setFormErrors={setFormErrors}
                dropdownData={dropdownData}
                disabled={disabled}
                setEditDisabled={setEditDisabled}
                setPointAddressForm={setPointAddressForm}
            />
            {/* Basic Information */}

            {/* Activity/Meeting Point Address */}
            <ActivityMeetingPointAddressSection
                ref={ActivityMeetingPointAddressSectionRef}
                PointAddressForm={PointAddressForm}
                setPointAddressForm={setPointAddressForm}
                formErrors={formErrors}
                setFormErrors={setFormErrors}
                dropdownData={dropdownData}
                disabled={disabled}
                setEditDisabled={setEditDisabled}
                ActivityId={BasicInformationForm?.ActivityId}
            />
            {/* Activity Point Address */}

            {/* Availability */}
            <PickupDropAvailabilitySection
                ref={PickupDropAvailabilitySectionRef}
                ActivityAddressLocationId={PointAddressForm?.ActivityBasicInfoAddress?.[0]?.LocationId}
                PickUpDropPointXML={PickUpDropPointXML}
                setPickUpDropPointXML={setPickUpDropPointXML}
                setPickUpDropDelete={setPickUpDropDelete}
                formErrors={formErrors}
                setFormErrors={setFormErrors}
                dropdownData={dropdownData}
                disabled={disabled}
                setEditDisabled={setEditDisabled}
            />
            {/* Availability */}

            {/* What you get? */}
            <WhatYouGetSection
                ref={WhatYouGetSectionRef}
                WhatYouGetList={WhatYouGetList}
                setWhatYouGetList={setWhatYouGetList}
                setWhatYouGetDelete={setWhatYouGetDelete}
                formErrors={formErrors}
                setFormErrors={setFormErrors}
                disabled={disabled}
                setEditDisabled={setEditDisabled}
            />
            {/* What you get? */}

            {/* Rest */}
            {/* <div className="container-fluid form_border my-2 py-3">

                <CustomColumn colNum={10} colLabel={4} colMDLabel={8} colChildren={2} colMDChildren={4} classChildren="align-content-center" labelText='Does this activity involve any risk of injury or to life?' labelId='SameAddressRadio' isRequired>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="yes"
                                    className="form-check-input"
                                    name="involverisk"
                                    value={1}
                                />
                                <label htmlFor="yes" className="form-check-label"> Yes </label>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="no"
                                    className="form-check-input"
                                    name="involverisk"
                                    value={2}
                                />
                                <label htmlFor="no" className="form-check-label"> No </label>
                            </div>
                        </div>
                    </div>
                </CustomColumn>

                <CustomColumn colNum={10} labelText='Type of risk' labelId='Typeofrisk'>
                    <input
                        type="text"
                        className='form-control'
                        name="Typeofrisk"
                        id="Typeofrisk"
                        disabled={disabled ? true : false}
                        placeholder='Type of risk'
                    />
                </CustomColumn>

                <CustomColumn colNum={10} labelText='Best Suited for' labelId='BestSuitedId' isRequired >
                    <Select
                        className="dropdown select_dropdown"
                        inputId='BestSuitedId'
                        options={list}
                        isSearchable
                        isDisabled={disabled ? true : false}
                        placeholder='Best Suited for'
                    />
                </CustomColumn>

                <CustomColumn colNum={10} labelText='Dress Code recommendation' labelId='DressCodeId' isRequired >
                    <Select
                        className="dropdown select_dropdown"
                        inputId='DressCodeId'
                        options={list}
                        isSearchable
                        isDisabled={disabled ? true : false}
                        placeholder='Dress Code'
                    />
                </CustomColumn>

            </div> */}
            {/* Rest */}

            <div className="text-center mt-5">
                <button type="button" className='btn btn-primary' disabled={editDisabled} onClick={handleSave} >
                    Save & Proceed
                </button>
            </div>

        </div>
    )
}

export default ActivityBasicInfo
